import { render, staticRenderFns } from "./FormularioEsterilizacion.vue?vue&type=template&id=319b1fa6&scoped=true&"
import script from "./FormularioEsterilizacion.vue?vue&type=script&lang=ts&"
export * from "./FormularioEsterilizacion.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioEsterilizacion.vue?vue&type=style&index=0&id=319b1fa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319b1fa6",
  null
  
)

export default component.exports